export const Routes = {
  AUTH: "/auth",
  HOME: "/home",
  ROOT: "/",
  CREATE_PATIENT: "/create-patient",
  NEW_VISIT: "/new-visit", // Points to the visit creation page
  ERROR: "/error",
  VISIT: "/visit",
  VISIT_DETAILS: "/visit-details",
  MESSAGES: "/messages",
  CHAT: "/chat",
  DEBUG: "/debug",
  PAST_VISITS: "/past-visits",
} as const;

export const ErrorCodes = {
  NO_PATIENTS: "NO_PATIENTS",
  PROFILE_NOT_FOUND: "PROFILE_NOT_FOUND",
  PATIENT_NOT_FOUND: "PATIENT_NOT_FOUND",
  PROFILE_INCOMPLETE: "PROFILE_INCOMPLETE",
  SESSION_ERROR: "SESSION_ERROR",
  DATABASE_ERROR: "DATABASE_ERROR",
  NO_INITIAL_CONTEXT: "NO_INITIAL_CONTEXT",
  UNKNOWN: "UNKNOWN_ERROR",
} as const;
